import { render, staticRenderFns } from "./IngestorsTable.vue?vue&type=template&id=45a38f2c"
import script from "./IngestorsTable.vue?vue&type=script&lang=js"
export * from "./IngestorsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports